import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon width="120" height="120" viewBox="0 0 120 120" {...props}>
      <title>{props.title || 'Hot'}</title>
      <g fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.1029 89.8009C23.1029 89.8009 8.70794 64.7046 15.9695 31.8032C23.2311 -1.0982 73.6201 17.9526 73.6201 17.9526C73.6201 17.9526 127.767 32.164 100.302 71.7602C72.8379 111.356 46.1292 137.235 23.1029 89.8009"
          fill="#556BDC"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.04736 74.1927C8.04736 74.1927 2.0616 45.8473 19.0687 16.8148C36.0758 -12.2176 78.1499 21.5739 78.1499 21.5739C78.1499 21.5739 125.283 51.9316 87.0069 81.0472C48.7305 110.163 15.3842 126.467 8.04736 74.1927"
          fill="#B51994"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M82.8322 34.4613C82.8322 34.4613 97.8739 56.084 93.9477 86.4718C90.0215 116.86 42.8976 103.527 42.8976 103.527C42.8976 103.527 -7.23738 94.8731 14.4307 56.8401C36.0987 18.807 58.1854 -6.73371 82.8322 34.4613"
          fill="#FF195A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M65.7995 14.8663C65.7995 14.8663 92.4931 25.7219 106.895 56.1485C121.297 86.5752 69.9376 102.789 69.9376 102.789C69.9376 102.789 18.5771 125.145 16.0003 76.9228C13.4234 28.701 18.6415 -8.24286 65.7995 14.8663"
          fill="#6E19B7"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M93.9805 42C95.6265 42 96.9609 40.6569 96.9609 39C96.9609 37.3431 95.6265 36 93.9805 36C92.3344 36 91 37.3431 91 39C91 40.6569 92.3344 42 93.9805 42Z"
          fill="#B51994"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.9805 98C34.6265 98 35.9609 96.6569 35.9609 95C35.9609 93.3431 34.6265 92 32.9805 92C31.3344 92 30 93.3431 30 95C30 96.6569 31.3344 98 32.9805 98Z"
          fill="#556BDC"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.9805 49C34.6265 49 35.9609 47.6569 35.9609 46C35.9609 44.3431 34.6265 43 32.9805 43C31.3344 43 30 44.3431 30 46C30 47.6569 31.3344 49 32.9805 49Z"
          fill="#FF195A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M57 19C58.1046 19 59 18.1046 59 17C59 15.8954 58.1046 15 57 15C55.8954 15 55 15.8954 55 17C55 18.1046 55.8954 19 57 19Z"
          fill="#B51994"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M86.987 74C88.0844 74 88.974 73.1046 88.974 72C88.974 70.8954 88.0844 70 86.987 70C85.8896 70 85 70.8954 85 72C85 73.1046 85.8896 74 86.987 74Z"
          fill="#FF195A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M55.1163 84.5788C55.1163 84.5788 36.2283 84.6504 36.2283 69.1432C36.2283 53.6361 53.0238 49.4065 53.0238 37.3685C53.0238 34.0616 52.1042 32.6105 50.124 30.7134C59.0537 30.9722 66.1522 39.566 66.1522 51.7662C66.1522 54.1919 65.2325 59.209 64.1289 60.2664C63.0252 61.3237 71.3024 55.4671 71.3024 50.3564C71.3024 50.3564 76.9613 55.5081 76.9613 66.6597C76.9613 77.8112 64.4823 85.7134 58.553 85.7134C62.2748 82.1477 64.8068 78.7554 64.8068 74.7461C64.8068 66.654 57.7281 67.3589 55.9778 63.2367V63.234C55.8571 62.9586 55.7709 62.6695 55.7192 62.3749C55.5525 61.2762 55.8428 60.1611 56.5297 59.2662L58.4581 56.6009C58.4553 56.6009 47.4654 59.6324 47.4654 70.9107C47.4654 82.189 53.3197 82.8522 55.1157 84.5792L55.1163 84.5788Z"
          fill="white"
        />
      </g>
    </Icon>
  )
}
